/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 28.08.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import ClassNames from 'classnames';

import {RDVR_STATES} from '../../../../utils';
import {FetchAssetById} from '../../../../actions/asset/action-asset';

import Tooltip from 'rc-tooltip';
import Translate from '../../../Translate';

import moment from 'moment';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';

class NpvrTile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      channelLogo: `/images/${Config.white_skin ? 'white' : 'black'}/no-channel-logo.png`,
      momentTime: moment.unix(_get(this.props, 'record.start_time') || _get(this.props, 'record.schedule_time'))
    }
  }

  componentWillMount() {

    if (this.props.channel.id) {

      lh.models.asset.methods.getPosterUrl(this.props.channel, {
        crop: {x: 30, y: 30},
        cache: false
      })
        .then((url) => {
          this.setState({channelLogo: url});
        }, () => {
        });
    } else {

      _get(this.props, 'record.channel_id') && this.props.FetchAssetById(_get(this.props, 'record.channel_id'));
    }
  }

  componentWillReceiveProps(newProps) {

    if (_get(this.props, 'record.channel_id') !== _get(newProps, 'record.channel_id')) {

      this.props.FetchAssetById(_get(newProps, 'record.channel_id'));
    }

    if (newProps.channel.id !== this.props.channel.id) {

      lh.models.asset.methods.getPosterUrl(newProps.channel, {
        crop: {x: 30, y: 30},
        cache: false
      })
        .then((url) => {
          this.setState({channelLogo: url});
        }, () => {
        });
    }

    this.setState({
      momentTime: moment.unix(_get(this.props, 'record.start_time') || _get(this.props, 'record.schedule_time'))
    });
  }

  shouldComponentUpdate(nextProps, nextState) {

    return !_isEqual(_get(nextProps, 'record', null), _get(this.props, 'record', null))
      || this.props.isSelected !== nextState.isSelected
      || this.state.channelLogo !== nextState.channelLogo;
  }

  _hasSubTitle() {

    return _get(this.props, 'record.title') !== _get(this.props, 'record.epg_program.title');
  }

  _renderRecordState() {

    switch (_get(this.props, 'record.state')) {
      case RDVR_STATES.FINISHED:

        return <Tooltip
          placement="top"
          destroyTooltipOnHide={true}
          overlay={<div className="rc-tooltip rc-tooltip-placement-top block-note bg-black radius p-">
            <Translate content={`npvr.status.finished`} />
          </div>}>
          <i className="ic ic-rdvr ic-18px rdvr-state-icon finished"></i>
        </Tooltip>;

      case RDVR_STATES.SCHEDULED:

        return <Tooltip
          placement="top"
          destroyTooltipOnHide={true}
          overlay={<div className="rc-tooltip rc-tooltip-placement-top block-note bg-black radius p-">
            <Translate content={`npvr.status.scheduled`} />
          </div>}>
          <i className="ic ic-rdvr ic-18px rdvr-state-icon scheduled"></i>
        </Tooltip>;

      case RDVR_STATES.RECORDING:

        return <Tooltip
          placement="top"
          destroyTooltipOnHide={true}
          overlay={<div className="rc-tooltip rc-tooltip-placement-top block-note bg-black radius p-">
            <Translate content={`npvr.status.recording`} />
          </div>}>
          <i className="ic ic-rdvr ic-18px rdvr-state-icon recording"></i>
        </Tooltip>;

      case RDVR_STATES.PENDING:

        return <Tooltip
          placement="top"
          destroyTooltipOnHide={true}
          overlay={<div className="rc-tooltip rc-tooltip-placement-top block-note bg-black radius p-">
            <Translate content={`npvr.status.pending`} />
          </div>}>
          <i className="ic ic-rdvr ic-18px rdvr-state-icon recording"></i>
        </Tooltip>;

      case RDVR_STATES.FAILED:

        return <Tooltip
          placement="top"
          destroyTooltipOnHide={true}
          overlay={<div className="rc-tooltip rc-tooltip-placement-top block-note bg-black radius p-">
            <Translate content={`npvr.status.failed`} />
          </div>}>
          <i className="ic ic-rdvr ic-18px rdvr-state-icon failed"></i>
        </Tooltip>;

      case RDVR_STATES.CANCELLED:

        return <Tooltip
          placement="top"
          destroyTooltipOnHide={true}
          overlay={<div className="rc-tooltip rc-tooltip-placement-top block-note bg-black radius p-">
            <Translate content={`npvr.status.cancelled`} />
          </div>}>
          <i className="ic ic-rdvr ic-18px rdvr-state-icon cancelled"></i>
        </Tooltip>;

      default:

        return null;
    }
  }

  render() {
    let npvrTileClass = ClassNames({
      'col-last': this.props['col'] === 3,
      'movie block-2-half bg-black radius showcase-row-channel-block': true
    });

    return (
      <div className={npvrTileClass} onClick={this.props.onRecordSelect.bind(this, this.props.record, this.props.row, this.props.col)}>
        <a href="javascript:void(0)" className="profile-show hover" rel="profile-program">
          {this.props.isSelected && <ReactCSSTransitionGroup transitionName="selection-animation" transitionAppear={true} transitionAppearTimeout={0} transitionEnterTimeout={0} transitionLeaveTimeout={0}>
            <i className="ic ic-selected-dot ic-10px asset-selected-icon"></i>
          </ReactCSSTransitionGroup>}

          <span className="block-note-rdvr rdvr-icons">

           {this._renderRecordState()}
            <div className="rdvr-channel">
              <span className="title-rdvr-channel"> {this.props.channel.title} </span>
              <img src={this.state.channelLogo} className="ico-rdvr-channel" alt={_get(this.props, 'channel.title')} />
            </div>
          </span>
          <span className="block-note-rdvr rdvr-title"><b>{_get(this.props, 'record.epg_program.title')}</b></span>
          {this._hasSubTitle() && <span className="block-note-rdvr rdvr-subtitle">
            <span className="program-title color-grey">{_get(this.props, 'record.title')}</span>
          </span>}
          <span className="block-note-rdvr rdvr-date"> {this.state.momentTime.format(_get(Config, 'npvr.record_time_format', 'HH:mm ddd, D MMM'))} </span>
        </a>
      </div>
    );
  }
}

NpvrTile.propTypes = {
  record: PropTypes.object.isRequired,
  channel: PropTypes.object,
  onRecordSelect: PropTypes.func.isRequired
};

const mapStateToProps = ({assets}, ownProps) => {
  let channel = _get(assets, _get(ownProps, 'record.channel_id'));

  return {
    channel: channel || {}
  };
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({FetchAssetById}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(NpvrTile);



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Tile/Npvr/npvr-tile.js